import { Pipe, PipeTransform } from '@angular/core';
import { FundStatsConfigKey, InjectConfig } from '@ddt-web/config-layer';

import { FundStatus } from '../models';

@Pipe({
	name: 'statusByColor'
})
export class StatusByColorPipe implements PipeTransform {
	@InjectConfig(FundStatsConfigKey.STATUSES) public readonly statuses: FundStatus[] = [];

	public transform(value: string): FundStatus {
		return this.statuses.find(item => item.statusId === value);
	}
}
